export const CloseCircle = ({ width, height, fill = '#D1005D' }: React.SVGProps<SVGSVGElement>) => (
	<svg width={width} height={height} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="36" cy="36" r="34" stroke={fill} strokeWidth="4" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M27.7017 22.1022C26.1801 20.5805 23.713 20.5805 22.1914 22.1022C20.6698 23.6238 20.6698 26.0908 22.1914 27.6125L30.4898 35.9109L22.1915 44.2091C20.6699 45.7307 20.6699 48.1978 22.1915 49.7194C23.7131 51.2411 26.1802 51.2411 27.7018 49.7194L36.0001 41.4211L44.2983 49.7194C45.82 51.2411 48.287 51.2411 49.8087 49.7194C51.3303 48.1978 51.3303 45.7307 49.8087 44.2091L41.5104 35.9109L49.8087 27.6126C51.3303 26.0909 51.3303 23.6239 49.8087 22.1023C48.287 20.5806 45.82 20.5806 44.2983 22.1023L36.0001 30.4005L27.7017 22.1022Z"
			fill={fill}
		/>
	</svg>
);
